
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class ForgotPassword extends Vue {
  public showPassword = false;
  public confirmEmailDialog = false;
  public formTitle = 'بازیابی رمز عبور';
  public countDown = 0;
  public confirmCode = '';
  public email = '';
  public password = '';
  public length = 4;

  async close() {
    this.confirmEmailDialog = false;
    this.confirmCode = '';
    this.countDown = 0;
  }

  async submit() {
    this.$showLoading();
    await Api.forgotPassword(this.email)
      .then((response: any) => {
        this.$showNotification('success', 'کد فعالسازی برای شما ارسال شد.');
        this.confirmEmailDialog = true;
        this.countDown = 120;
        this.countDownTimer();
        this.$hideLoading();
      })
      .catch(async () => {
        if (this.$refs.captcha) {
          (this.$refs.captcha as any).getNewCaptcha();
        }
      });
  }

  async confirmPassword() {
    this.$showLoading();
    await Api.confirmForgotPassword(this.confirmCode, this.password, this.email)
      .then((response: any) => {
        this.$showNotification('success', 'بازیابی با موفقیت انجام شد.');
        this.$router.push({ name: 'Login' });
        this.$hideLoading();
      })
      .catch(async () => {
        if (this.$refs.captcha) {
          (this.$refs.captcha as any).getNewCaptcha();
        }
      });
  }

  countDownTimer() {
    if (this.countDown > 0) {
      setTimeout(() => {
        this.countDown -= 1;
        this.countDownTimer();
      }, 1000);
    }
  }
}
